import PortalIdParser from 'PortalIdParser';
import { DESC } from 'framework-listing-lib/constants/sorts';
import { VIEW_TYPE } from 'framework-listing-lib/internal/ViewTabs/constants/views';
import { combineFilters } from 'framework-listing-lib/utils/filters';
import { UI_MODE } from '../../../constants';

/**
 * Creates a view request used to save views (create or update) in the BE.
 * If taking and existing view (@view is defined), it will use its current information to update a view.
 * Otherwise, it is going to return a view to create.
 */
export function buildViewUpdate({
  cardProperties,
  columns,
  currentUIMode,
  filterGroups,
  hiddenFilter,
  numberOfFrozenColumns,
  objectType,
  quickFilters,
  quickFilterPropertyNames,
  sort,
  view,
  viewUpdateState
}) {
  const viewFilterGroups = hiddenFilter ? combineFilters(filterGroups, hiddenFilter.filterGroups) : filterGroups;
  return {
    columns: columns.map((name, index) => ({
      name,
      order: index + 1
    })),
    id: view ? String(view.id) : null,
    filterGroups: viewFilterGroups,
    filters: [],
    name: view ? view.name : '',
    ownerId: view ? view.ownerId : null,
    objectTypeId: objectType,
    portalId: PortalIdParser.get(),
    private: view ? view.private : false,
    quickFilters,
    quickFilterProperties: quickFilterPropertyNames.map(name => ({
      name
    })),
    state: {
      cardProperties,
      order: sort.order === DESC ? 1 : -1,
      sortKey: sort.property,
      mLangGroup: {
        showAll: viewUpdateState.mLangGroup.showAll
      },
      numberOfFrozenColumns,
      uiMode: currentUIMode === UI_MODE.FOLDERS ? UI_MODE.LIST : String(currentUIMode)
    },
    teamId: view ? view.teamId : null,
    type: view ? view.type : VIEW_TYPE.STANDARD
  };
}
export function getViewWithNewFilters({
  filtersForNewViews,
  viewUpdate
}) {
  return Object.assign({}, viewUpdate, {
    filterGroups: filtersForNewViews.filterGroups,
    filters: [],
    quickFilters: filtersForNewViews.quickFilters
  });
}
export function convertCustomerDataViewToView(customerDataView) {
  return {
    columns: customerDataView.columns.map(({
      name
    }, index) => ({
      name,
      order: index
    })),
    filters: [],
    // Different TS types between FLL and customer-data-views-management
    filterGroups: customerDataView.filterGroups,
    // Different TS types between FLL and customer-data-views-management
    quickFilters: customerDataView.quickFilters,
    quickFilterProperties: customerDataView.quickFilterProperties,
    /**
     * NOTE: customer-data-views-management uses the "idLabel" as the view "id"
     */
    id: customerDataView.id,
    idLabel: customerDataView.idLabel,
    name: customerDataView.name,
    namespace: customerDataView.namespaceName,
    objectTypeId: customerDataView.objectTypeId,
    ownerId: customerDataView.ownerId || null,
    portalId: PortalIdParser.get(),
    private: customerDataView.private,
    // Different TS types between FLL and customer-data-views-management
    state: customerDataView.state,
    teamId: customerDataView.teamId || null,
    type: customerDataView.type
  };
}
export function convertViewToCustomerDataView({
  view
}) {
  return {
    id: view.id,
    name: view.name,
    objectTypeId: view.objectTypeId,
    idLabel: view.idLabel,
    ownerId: view.ownerId || undefined,
    teamId: view.teamId || undefined,
    private: view.private,
    type: view.type,
    columns: view.columns,
    // Different TS types between FLL and customer-data-views-management
    state: view.state,
    namespaceName: view.namespace,
    filterGroups: view.filterGroups,
    quickFilters: view.quickFilters,
    quickFilterProperties: view.quickFilterProperties
  };
}
export function convertViewUpdateToCustomerDataView({
  viewUpdate,
  namespace
}) {
  return convertViewToCustomerDataView({
    view: Object.assign({}, viewUpdate, {
      id: viewUpdate.id || '',
      namespace
    })
  });
}